import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { BorderWrapper, Title, TableData } from 'components/styled-components';
import moment from 'moment';
import colors from 'utils/colors';
import { PaddingWrapper } from '../styled-components';
import { fetchPrescreenInstance } from 'actions/prescreen';
import constants from 'utils/constants';
import { Icon } from '@blueprintjs/core';

const { REVIEW_STATUSES } = constants;

const ReviewToHtml = (response) => {
	let style = { marginRight: "5px" };
	switch(response.value){
		case null:
		case 4:
			style.backgroundColor = "#ffd000";
			break;
		case 0:
		case 1:
		case 2:
			style.backgroundColor = "green";
			break;
		case 3:
			style.backgroundColor = "red";
			break;
		default:
	}

	return <span><LightIcon style={style} />{response.label}</span>
}

const ReviewAccess = (user, DepartmentID, reviews) => {
	// completed reviews
	const completed_reviews = reviews.filter(r => r.Response !== null && r.Response !== 4); //not In Review and not Not Reviewed
	if(user.role === 'ADMINISTRATOR')
		return true;
	if(completed_reviews.length >= reviews.length) //non-admins cannot edit if all reviews are done
		return false;
	if(user.role === 'DEPARTMENT_REVIEWER' && user.departmentID == DepartmentID)
		return true;
	return false;
}

const AdminAccess = (user) => {
	return user.role === 'ADMINISTRATOR';
}

const ReviewRow = ({ departmentName, review, openReview, sendNotice, access, admin }) => (
  <TableRow>
		{admin ? <TableData><Icon icon={'notifications'} iconSize={Icon.SIZE_SMALL} style={{cursor: "pointer"}} onClick={sendNotice} /></TableData> : ""}
    <TableData>{departmentName}</TableData>
    <TableData>{ReviewToHtml(REVIEW_STATUSES.find(rs => rs.value === review.Response))}</TableData>
    <TableData>
			{review.mod_dt !== null ? <div>{moment(review.mod_dt).format('LL')}</div> : ""}
			{review.UserID !== null ? <div style={{cursor: "pointer"}} title={`Click to Copy: ${review.Email}`} onClick={() => navigator.clipboard.writeText(review.Email)}>{`${review.FirstName} ${review.LastName}`}</div> : ""}
		</TableData>
    <TableData>{review.Comment}</TableData>
    <TableData style={{textAlign: "center"}}>
		{!access ? '' :
			<span onClick={openReview} style={{cursor: "pointer"}}>Edit</span>
		}
	</TableData>
  </TableRow>
);

const DepartmentalReviewsFunction = ({
	request,
	departments,
	openReview,
	sendNotice,
	appUser
  }) => {
	const { DepartmentalReviews } = request;
	const admin = AdminAccess(appUser);
	return (
	  <BorderWrapper margin="1rem">
		<PaddingWrapper>
		  <Heading>
			<Title>Departmental Reviews</Title>
		  </Heading>
		</PaddingWrapper>
		<Table>
		  <thead>
			<TableRow>
				{admin ? <TableHead style={{"maxWidth": "20px"}}></TableHead> : ""}
			  <TableHead style={{"minWidth": "200px"}}>Department</TableHead>
			  <TableHead style={{"minWidth": "150px"}}>Response</TableHead>
			  <TableHead style={{"minWidth": "150px"}}>Last Updated</TableHead>
			  <TableHead>Comments</TableHead>
			  <TableHead style={{"width": "75px"}}>Action</TableHead>
			</TableRow>
		  </thead>
		  <tbody>
			  {DepartmentalReviews.map((review, key) => {
				  const departmentName = departments.find(d => d.departmentID == review.DepartmentID) ? departments.find(d => d.departmentID == review.DepartmentID).departmentName : "";
				  return <ReviewRow key={key} departmentName={departmentName} review={review} openReview={() => openReview(review.ReviewID)} sendNotice={() => sendNotice(review.VendorRequestID, review.DepartmentID)} admin={admin} access={ReviewAccess(appUser, review.DepartmentID, DepartmentalReviews)} />;
			  })}
		  </tbody>
		</Table>
	  </BorderWrapper>
	);
  };

const Heading = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 3px;
`;

const TableRow = styled.tr`
  background: ${props => props.background || '#fff'};

  td {
    border-bottom: 1px solid ${colors.lightestGray};
  }
  &:first-child th {
    border-bottom: 1px solid ${colors.lightestGray};
  }
  &:last-child {
    border-bottom: none;
  }
`;

const TableHead = styled.th`
  text-align: left;
  color: ${colors.lightGray};
  margin-bottom: 0.5rem;
  font-weight: 400;
  padding: 1rem;
  border-bottom: 1px solid ${colors.lightGray};
`;

const LightIcon = styled.span`
	display: inline-block;
	width: 1em;
    height: 1em;
    margin-bottom: 0.1em;
	border-radius: 20px;
	box-shadow: inset 0 0 4px #ffffff;
	vertical-align: middle;
`;

const mapStateToProps = state => ({
	files: state.utils.prescreenFiles,
	instance: state.prescreen.instance,
	appUser: state.auth.appUser,
});

const DepartmentalReviews = connect(
	mapStateToProps,
	{ fetchPrescreenInstance }
  )(DepartmentalReviewsFunction);

export default DepartmentalReviews;
